import { MouseEvent } from 'react';
import { Portal } from '@radix-ui/react-portal';
import classNames from 'classnames';

import styles from './JabraLoader.module.css';

export interface JabraLoaderProps {
  global?: boolean;
}
export const JabraLoader = ({ global }: JabraLoaderProps) => {
  const preventPropagate = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const Loader = () => (
    <div
      onClick={preventPropagate}
      onMouseDown={preventPropagate}
      className={`left-0 top-0 z-[999999] flex h-full w-full items-center justify-center bg-black bg-opacity-50 ${
        global ? 'fixed' : 'absolute'
      }`}
    >
      <div className="flex gap-2">
        <div className={classNames('h-8 w-4 bg-white', styles.animatePing)}></div>
        <div className={classNames('h-8 w-4 bg-white !delay-100', styles.animatePing)}></div>
        <div className={classNames('h-8 w-4 bg-white !delay-200', styles.animatePing)}></div>
      </div>
    </div>
  );

  if (global) {
    return (
      <Portal>
        <Loader />
      </Portal>
    );
  }
  return <Loader />;
};
